//export class SupplierFileCabinetBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: SupplierFileCabinetGeneratedForm}];
//};

//export class SupplierFileCabinetListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: SupplierFileCabinetListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/SupplierFileCabinetDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class SupplierFileCabinetEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplierFileCabinet/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class SupplierFileCabinetFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public supplierId: IFieldOptions = { field: "supplierId" };
	public fileCabinetId: IFieldOptions = { field: "fileCabinetId" };
	public supplierFileCabinetTypeId: IFieldOptions = { field: "supplierFileCabinetTypeId" };
	public expiryDate: IFieldOptions = { field: "expiryDate" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.supplierId);
		this.push(this.fileCabinetId);
		this.push(this.supplierFileCabinetTypeId);
		this.push(this.expiryDate);
	}
}

export class SupplierFileCabinetForm implements IFormOptions {
	protected supplierFileCabinetFormName: string = "supplierFileCabinetForm";
	protected supplierFileCabinetFormModel: models.SupplierFileCabinetDTO = new models.SupplierFileCabinetDTO();
	protected supplierFileCabinetFormEndPoints: SupplierFileCabinetEndPoints = new SupplierFileCabinetEndPoints();
	protected supplierFileCabinetFormFields: SupplierFileCabinetFormFields = new SupplierFileCabinetFormFields();
	public get name(): string { return this.supplierFileCabinetFormName };
	public get model(): models.SupplierFileCabinetDTO { return this.supplierFileCabinetFormModel };
	public get endPoints(): IEntityEndPoints { return this.supplierFileCabinetFormEndPoints };
       public set endPoints(supplierFileCabinetEndPoints: IEntityEndPoints) {
		this.supplierFileCabinetFormEndPoints = supplierFileCabinetEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): SupplierFileCabinetFormFields { return this.supplierFileCabinetFormFields };
}

export class SupplierFileCabinetListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public supplierId: IColumnOptions = { field: "supplierId" };
	public fileCabinetId: IColumnOptions = { field: "fileCabinetId" };
	public supplierFileCabinetTypeId: IColumnOptions = { field: "supplierFileCabinetTypeId" };
	public expiryDate: IColumnOptions = { field: "expiryDate", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.supplierId);
		this.push(this.fileCabinetId);
		this.push(this.supplierFileCabinetTypeId);
		this.push(this.expiryDate);
	}
}

export class SupplierFileCabinetList implements IGridOptions {
	protected supplierFileCabinetListName: string = "supplierFileCabinetList";
	protected supplierFileCabinetListModel: models.SupplierFileCabinetDTO = new models.SupplierFileCabinetDTO();
	protected supplierFileCabinetListEndPoints: SupplierFileCabinetEndPoints = new SupplierFileCabinetEndPoints();
	protected supplierFileCabinetListColumns: SupplierFileCabinetListColumns = new SupplierFileCabinetListColumns();
	public supplierFileCabinetForm: SupplierFileCabinetForm = new SupplierFileCabinetForm();
	public get name(): string { return this.supplierFileCabinetListName };
	public get model(): models.SupplierFileCabinetDTO { return this.supplierFileCabinetListModel };
	public get endPoints(): IEntityEndPoints { return this.supplierFileCabinetListEndPoints };
	public set endPoints(supplierFileCabinetEndPoints: IEntityEndPoints) {
		this.supplierFileCabinetListEndPoints = supplierFileCabinetEndPoints;
		this.supplierFileCabinetForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): SupplierFileCabinetListColumns { return this.supplierFileCabinetListColumns };
}

export class SupplierFileCabinetEntity implements IEntityOptions {
	protected supplierFileCabinetEntityName: string = "supplierFileCabinetEntity";
	protected supplierFileCabinetEntityModel: models.SupplierFileCabinetDTO = new models.SupplierFileCabinetDTO();
	protected supplierFileCabinetEntityEndPoints: SupplierFileCabinetEndPoints = new SupplierFileCabinetEndPoints();
	protected supplierFileCabinetEntityList: SupplierFileCabinetList = new SupplierFileCabinetList();
	public get name(): string { return this.supplierFileCabinetEntityName };
	public get model(): models.SupplierFileCabinetDTO { return this.supplierFileCabinetEntityModel };
	public get endPoints(): IEntityEndPoints { return this.supplierFileCabinetEntityEndPoints };
	public set endPoints(supplierFileCabinetEndPoints: IEntityEndPoints) {
		this.supplierFileCabinetEntityEndPoints = supplierFileCabinetEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): SupplierFileCabinetList { return this.supplierFileCabinetEntityList };
	public get form(): SupplierFileCabinetForm { return this.grid.supplierFileCabinetForm };
	constructor(name?: string) {
		if (name) this.supplierFileCabinetEntityName = name;
		this.endPoints = this.supplierFileCabinetEntityEndPoints;
	}
};
//export class SupplierFileCabinetGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: SupplierFileCabinetForm = new SupplierFileCabinetForm();
//};

//export class SupplierFileCabinetListPageComponent extends ListPageComponent {
  //protected listPageComponentList: SupplierFileCabinetList = new  SupplierFileCabinetList();
  //protected showFilterColOnTable: boolean = true;
//};

